import useAuthenticatedQuery from "./useAuthenticatedQuery";

const useGetSubscriptionPlans = (enabled = false) => {
  const {
    data: plans,
    isLoading: plansLoading,
    error: plansError,
    refetch: refetchPlans,
  } = useAuthenticatedQuery(
    ["subscriptionPlans"],
    "/api/v1/subscriptions/plans",
    {
      // Only fetch when enabled and on subscription page
      enabled,
    }
  );

  return {
    plans,
    plansLoading,
    plansError,
    refetchPlans,
  };
};

export default useGetSubscriptionPlans;
